import React from "react";

interface UsageChartProps {
  className?: string;
}

// Mock data for the chart
const usageData = [
  { day: "Mon", height: 45 },
  { day: "Tue", height: 60 },
  { day: "Wed", height: 40 },
  { day: "Thu", height: 70 },
  { day: "Fri", height: 55, active: true },
  { day: "Sat", height: 35 },
  { day: "Sun", height: 25 },
];

export const UsageChart: React.FC<UsageChartProps> = ({ className }) => {
  return (
    <section className={`w-full ${className || ""}`}>
      <div className="flex flex-col p-4 bg-white rounded-xl border border-gray-200 shadow-sm">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-base font-semibold text-gray-900">Weekly Usage</h3>
          <div className="flex gap-2">
            <button className="px-3 py-1.5 text-sm font-medium text-gray-500 bg-gray-100 rounded-full">Day</button>
            <button className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-full">Week</button>
            <button className="px-3 py-1.5 text-sm font-medium text-gray-500 bg-gray-100 rounded-full">Month</button>
          </div>
        </div>
        
        <div className="flex flex-col h-48">
          <div className="flex justify-between items-end h-36 mb-3">
            {usageData.map((item, index) => (
              <div key={index} className="flex flex-col items-center w-10">
                <div 
                  className={`w-3 rounded ${item.active ? 'bg-blue-600' : 'bg-gray-400'}`}
                  style={{ height: `${item.height}%` }}
                ></div>
                <span className="text-xs text-gray-500 mt-2">{item.day}</span>
              </div>
            ))}
          </div>
          
          <div className="flex justify-end gap-4 mt-3">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
              <span className="text-xs text-gray-500">Today</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
              <span className="text-xs text-gray-500">Previous days</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
